import request from '@/utils/axios'
import { METO8_API_BASE } from '@/config/meto8ApiBase'

// 获取验证码
export function captchaImage() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

// 注册
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data
  })
}

// 账号密码登录
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// // 获取用户信息接口
// export function getInfo() {
//   return request({
//     url: '/getInfo',
//     method: 'get'
//   })
// }
//
// // 积分信息
// export function getStatistic() {
//   return request({
//     url: '/incentive/user/statistic',
//     method: 'get'
//   })
// }
//
// // 获取用户信息接口
// export function logout() {
//   return request({
//     url: '/logout',
//     method: 'get'
//   })
// }
//
// // 提问
// export function knowledgeSearch(data) {
//   return request({
//     url: '/ai/knowledge/search',
//     method: 'post',
//     data
//   })
// }


// web获取模型配置列表
export function getModelConfig(query) {
  return request({
    url: '/system/aiSettings/getModelConfig?referer=metoai666.com',
    method: 'get',
    params: query
  })
}

// 知识库列表
export function knowledgeLibrary() {
  return request({
    url: '/ai/knowledge/library',
    method: 'get'
  })
}

// 搜索建议
export function knowledgeSuggestions() {
  return request({
    url: '/ai/knowledge/suggestions?_=' + +new Date(),
    method: 'get'
  })
}

// // 初始化对话组（发送首条消息）
// export function initConversation(data) {
//   return request({
//     url: '/ai/knowledge/message/initConversation',
//     method: 'post',
//     data
//   })
// }
//
// // 初发送消息（需额外提问）
// export function messageSend(data) {
//   return request({
//     url: '/ai/knowledge/message/send',
//     method: 'post',
//     data
//   })
// }
//
// // 消息删除
// export function messageDel(messageId) {
//   return request({
//     url: '/ai/knowledge/message/' + messageId,
//     method: 'delete'
//   })
// }
//
// // 对话组列表（侧边）
// export function conversationList(params) {
//   return request({
//     url: '/ai/knowledge/conversation/list',
//     method: 'get',
//     params
//   })
// }
//
// // 对话组id删除
// export function conversationDel(conversationId) {
//   return request({
//     url: '/ai/knowledge/conversation/remove/' + conversationId,
//     method: 'delete'
//   })
// }
//
// //弃用 对话组明细(消息列表, 上限200条)
// export function conversationDetail(conversationId, data) {
//   return request({
//     url: `/ai/knowledge/message/${conversationId}/list`,
//     method: 'get',
//     params: {
//       ...data
//     }
//   })
// }


export function sendLoginMsg(phoneNumber) {
  return request({
    url: `${METO8_API_BASE}/api/login_phone`,
    method: 'post',
    data: {
      "phone_number": phoneNumber,
      "task_id": 0
    }
  })
}
export function msgLogin(phoneNumber, code) {
  return request({
    url: `${METO8_API_BASE}/api/login_phone`,
    method: 'post',
    data: {
      "phone_number": phoneNumber,
      "task_id": 1,
      "verify_code": code,
    }
  })
}


/** 刷新已登录用户资料（积分、会员天数等每日更新字段） */
export function refreshUserInfo(phoneNumber) {
  return request({
    url: `${METO8_API_BASE}/api/login_phone`,
    method: 'post',
    data: {
      phone_number: phoneNumber,
      task_id: 3,
    },
  })
}


// 获取会话列表-v2
export function listConversation(userName) {
  return request({
    url: `${METO8_API_BASE}/api/get_meto666_history`,
    method: 'post',
    data: {
      "user_name": userName,
      "task_id": 0,
    }
  })
}


// 存储对话信息-v2
export function saveConversationMsg(data) {
  return request({
    url: `${METO8_API_BASE}/api/save_meto666_history`,
    method: 'post',
    data
  })
}


// 获取对话信息-v2
export function listConversationMsg(userName, conversationId) {
  return request({
    url: `${METO8_API_BASE}/api/get_meto666_history`,
    method: 'post',
    data: {
      "user_name": userName,
      "conversation_id": conversationId,
      "task_id": 1,
    }
  })
}
// 删除对话信息-v2
export function delConversationMsg(userName, conversationId) {
  return request({
    url: `${METO8_API_BASE}/api/delete_meto666_history`,
    method: 'post',
    data: {
      "user_name": userName,
      "conversation_id": conversationId
    }
  })
}

/** 会员充值相关（与 meto8 同源，路径 /api/recharge） */
export function postMeto8Recharge(data) {
  return request({
    url: `${METO8_API_BASE}/api/recharge`,
    method: 'post',
    data
  })
}

// 获取密钥
export function getSecretKey(value) {
  return request({
    // url: `http://localhost:8080/api/query/algorithmAuthorize?value=${value}`,
    url: `https://jssj666.com/prod-api/api/query/algorithmAuthorize?value=${value}`,
    method: 'get',
  })
}
